import React, { useEffect } from "react";
import { Button, Form, Modal } from "reactstrap";
import { useForm } from "react-hook-form";
import { useState } from "react";
import CustomeButton from "../../Forms/CustomeButton/CustomeButton";
import { useRole } from "../../../../redux/slices/authSlice";
import ControlledDropDown from "../../Forms/Controller/ControlledDropDown";
import { PaymentMetaLabelListGet } from "../../../../redux/slices/transactionSlice";
import { useDispatch, useSelector } from "react-redux";
import Percentage from "./Percentage";
import Merchant from "./Merchant";
import { UpdateStaticPgMeta } from "../../../../redux/slices/staticPgMetaSlice";
import { responseToaster } from "../../../../helperFunctions";
import { showToaster } from "../../../../constant";

const ChangeBankModal = (props) => {
  const {
    onCloseChangeBankModal,
    changeBankModal,
    merchants,
    bankId,
    bankOptions,
    paymentMetaLabelList,
    paymentMetaLabelListGetData,
    preparepgDataOptions,
    showTableData,
    onGet,
  } = props;
  const [percentageList, setPercentageList] = useState([]);
  const [merchantList, setMerchantList] = useState([]);
  const [paymentMetaLabelListGetData1, setPaymentMetaLabelListGetData1] =
    useState([]);
  const [loading, setLoading] = useState({
    pgLoading: false,
    pgAccLoading: false,
    submitData: false,
  });

  const { transactionFilterState } = useSelector((state) => state.transaction);
  const role = useRole("Static Pg Meta");
  const dispatch = useDispatch();

  const onClose = () => {
    reset();
    onCloseChangeBankModal();
    setPercentageList([]);
    setMerchantList([]);
    setPaymentMetaLabelListGetData1([]);
    setLoading({
      pgLoading: false,
      pgAccLoading: false,
      submitData: false,
    });
  };

  const initialValues = {
    merchantEmail: "",
    merchantName: "",
    Mode: "merchant",
    BankSelect: "",
    BankPercentage: "",
    MerchantSelect: "",
    BankForMerchant: "",
    pgName: "",
  };

  const { control, handleSubmit, reset, watch } = useForm({
    defaultValues: initialValues,
  });

  const mode = watch("Mode");
  const PaymentMetaLabelList = async () => {
    try {
      const pgName = transactionFilterState?.pg_data?.find((data) => {
        return data?.pg_id == watch("pgName");
      });

      let payload = {
        pgType: "payin",
        pgName: pgName?.pg_name ? [pgName?.pg_name] : "All",
        pg_id: watch("pgName") || "all",
        notSetState: true,
      };
      setLoading({ ...loading, pgAccLoading: true });
      const res = await dispatch(PaymentMetaLabelListGet(payload)).unwrap();
      if (res?.status) {
        setPaymentMetaLabelListGetData1(res);
      }
      setLoading({ ...loading, pgAccLoading: false });
    } catch (e) {}
  };

  const pgName = watch("pgName");
  const pgPerName = watch("pgPerName");

  useEffect(() => {
    if ((pgName && changeBankModal) || (pgPerName && changeBankModal)) {
      PaymentMetaLabelList(); // make sure this doesn’t itself set pgName
    }
  }, [pgName, pgPerName, changeBankModal]);

  const onSubmit = async (arg = []) => {
    try {
      const clonedMerchant = merchantList?.length ? merchantList : arg;
      const clonedPer = percentageList?.length ? percentageList : arg;

      const total = clonedPer?.reduce?.(
        (sum, item) => sum + (item?.value || 0),
        0
      );

      const isHundred = total === 100;

      if (!isHundred && mode === "percentage") {
        showToaster(`Percentage total must be 100%, got ${total}%`, "Warning");
        return;
      }

      let payload = {};
      if (mode === "merchant") {
        payload = {
          details: clonedMerchant?.map?.((item) => {
            const pgInfo = transactionFilterState?.pg_data?.find?.(
              (pg) => pg?.pg_id === item?.pgName
            );
            return {
              pgId: item?.bank,
              pgName: pgInfo?.pg_name || null,
              merchantId: item?.merchant,
            };
          }),
          fromBank:
            bankId || changeBankModal?.pg_id || clonedMerchant?.[0]?.fromBank,
          type: mode,
        };
      } else {
        payload = {
          details: clonedPer?.map?.((item) => {
            const pgInfo = transactionFilterState?.pg_data?.find?.(
              (pg) => pg?.pg_id === item?.pgNameVal
            );
            return {
              pgId: item?.bank,
              pgName: pgInfo?.pg_name || null,
              per: item?.value,
            };
          }),
          fromBank:
            bankId || changeBankModal?.pg_id || clonedPer?.[0]?.fromBank,
          type: "per",
        };
      }
      setLoading({ ...loading, submitData: true });
      const res = await dispatch(UpdateStaticPgMeta(payload)).unwrap();
      setLoading({ ...loading, submitData: false });
      responseToaster(res);
      if (res?.status) {
        onClose();
        onGet?.();
      }
    } catch (error) {
      setLoading({ ...loading, submitData: false });
    }
  };

  const getpgAccDataOptions = () => {
    const options = paymentMetaLabelListGetData1?.data
      ?.slice()
      ?.sort((a, b) => a?.note?.localeCompare(b?.note))
      ?.map((val) => {
        const pgAccDataOption = { value: val?.acId, label: val?.note };
        return pgAccDataOption;
      });
    return options;
  };

  if (!role.includes("static-pg-meta-list") || !changeBankModal) {
    return;
  }

  return (
    <Modal
      className="add-manual-payout-modal modal-lg"
      backdrop={"static"}
      isOpen={changeBankModal}
      toggle={onClose}
      centered={true}
    >
      <Form onSubmit={handleSubmit(onSubmit)}>
        <div className="modal-header">
          <h3 className="modal-title mt-0">Change Bank</h3>
          <div className="d-flex gap-2 align-items-center">
            <ControlledDropDown
              name="Mode"
              isDefaultOption={false}
              options={[
                { label: "Percentage", value: "percentage" },
                { label: "Merchant", value: "merchant" },
              ]}
              control={control}
            />
            <i
              onClick={() => {
                onClose();
              }}
              className="fa-solid fa-xmark"
            ></i>
          </div>
        </div>
        <div className="p-1 modal-body">
          {mode === "merchant" && (
            <Merchant
              changeBankModal={changeBankModal}
              onCloseChangeBankModal={onCloseChangeBankModal}
              merchants={merchants}
              bankId={bankId}
              bankOptions={bankOptions}
              paymentMetaLabelList={paymentMetaLabelList}
              paymentMetaLabelListGetData={paymentMetaLabelListGetData}
              preparepgDataOptions={preparepgDataOptions}
              getpgAccDataOptions={getpgAccDataOptions}
              showTableData={showTableData}
              merchantList={merchantList}
              setMerchantList={setMerchantList}
              handleSubmit={onSubmit}
              submitLoader={loading?.submitData}
            />
          )}
          {mode === "percentage" && (
            <Percentage
              changeBankModal={changeBankModal}
              onCloseChangeBankModal={onCloseChangeBankModal}
              merchants={merchants}
              bankId={bankId}
              bankOptions={bankOptions}
              paymentMetaLabelList={paymentMetaLabelList}
              paymentMetaLabelListGetData={paymentMetaLabelListGetData}
              preparepgDataOptions={preparepgDataOptions}
              getpgAccDataOptions={getpgAccDataOptions}
              showTableData={showTableData}
              percentageList={percentageList}
              setPercentageList={setPercentageList}
              handleSubmit={onSubmit}
              submitLoader={loading?.submitData}
            />
          )}
        </div>

        <div className="modal-footer">
          <div className="d-flex justify-content-end button-space">
            <Button
              type="button"
              className="graybutton"
              onClick={() => onClose()}
            >
              Cancel
            </Button>
            {!(!showTableData && !changeBankModal?.pg_id) ? (
              <CustomeButton
                className="submitbutton"
                type="submit"
                isButtonLoading={loading?.submitData}
              >
                Submit
              </CustomeButton>
            ) : null}
          </div>
        </div>
      </Form>
    </Modal>
  );
};

export default ChangeBankModal;
